export const NVIDIA_CERT_SLUG =
  'scaling-ai-strategy-build-launch-and-drive-what-s-next'
